import React from 'react';
import AllIcons from '../components/dev/AllIcons';

const DevRoutes = {
  path: 'dev',
  children: [
    {
      path: 'icons',
      element: <AllIcons />,
    },
  ],
};

export default DevRoutes;
